module.exports = __webpack_public_path__ + "assets/ic-coinmarketcap.d75a7d40.svg";